const latexIgnoredParentTags = new Set([
  'code',
  'pre',
  'script',
  'style',
  'textarea',
  'input',
]);

export const shouldSkipLatexParentTag = (tagName?: string) =>
  Boolean(tagName && latexIgnoredParentTags.has(tagName));

export const hasLatexExpression = (text: string) => {
  const textWithoutEscapedDollars = text.replace(/\\\$/g, '');
  return /\$\$[\s\S]+?\$\$|\$(?!\d)(?:\\\$|[^\n$])+\$/.test(
    textWithoutEscapedDollars
  );
};

/**
 * Source of a regex alternative that matches ONE delimited LaTeX run, delimiters
 * included, in the four forms react-latex-next renders by default: `$$…$$` and
 * `\[…\]` display math, `\(…\)` and `$…$` inline math. Single-dollar math must
 * not start with a digit, so "$5 and $10" stays prose. Meant to be spliced
 * into a larger tokenizer (the chat markdown renderer) ahead of its markdown
 * alternatives, so the `*`, `_` and `[` inside an equation are never read as
 * markdown.
 */
export const LATEX_DELIMITED_SOURCE =
  '\\$\\$[\\s\\S]+?\\$\\$|\\\\\\[[\\s\\S]+?\\\\\\]|\\\\\\([\\s\\S]+?\\\\\\)|\\$(?!\\d)(?:\\\\\\$|[^\\n$])+\\$';

/** True for a token the pattern above produced. */
export const isLatexToken = (token: string): boolean =>
  token.startsWith('$') || token.startsWith('\\(') || token.startsWith('\\[');
